import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LogoLink from "../../atoms/LogoLink";
import styles from "./Footer.module.scss";
import LinkedIn from "./Linkedin.svg";

type Props = {};

const links = [
  {
    name: "Meet Regie",
    url: "https://regie.ai/team/",
  },
  {
    name: "Sales Tools",
    url: "https://regie.ai/regie-for-sales/",
  },
  {
    name: "Contact Us",
    url: "https://regie.ai/contact-us/",
  },
  {
    name: "Support",
    url: "https://support.regie.io/hc/en-us",
  },
  {
    name: "Privacy policy",
    url: "https://regie.ai/privacy-policy/",
  },
];

const Footer: React.FC<Props> = (props) => {
  return (
    <footer className={styles.footer}>
      <Container className={styles.container}>
        <LogoLink />
        <Row>
          {links.map(({ url, name }) => {
            return (
              <Col md="auto">
                <a className={styles.link} href={url}>
                  {name}
                </a>
              </Col>
            );
          })}
        </Row>
        <a href="https://www.linkedin.com/company/regie-io/">
          <img src={LinkedIn} alt="" />
        </a>
      </Container>
    </footer>
  );
};

export default Footer;
